<template>
  <div class="pd-20 pd-lg-25 pd-xl-30">
    <ul class="list-group">
      <li
        @click="$emit('on-detail', t)"
        class="list-group-item d-flex align-items-center"
        v-for="(t, i) in topics"
        :key="i"
        role="button"
      >
        <div class="avatar">
          <span :class="`avatar-initial rounded-circle op-5 bg-primary`">
            {{ t.commentCount }}
          </span>
        </div>
        <div class="pd-l-10">
          <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ t.task }}</h6>
          <span class="d-block tx-11 text-muted">{{
            t.createdDate | moment("LLLL")
          }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      topics: []
    };
  },
  mounted() {
    //console.log(this.task);
    let tb = this.task.b.filter(x => x.ot == 125);
    if (tb.length) {
      //console.log(tb[0].id);
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
        data: { id: tb[0].id, skip: 0, size: 100 },
        store: this.$store
      }).then(res => {
        //this.toggleBodyClass('removeClass', 'dynamic-locker');
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        if (res != false) {
          this.topics = res.data.tasks;
          //console.log('coreBoxInTaskList=> ', res.data);
        }
      });
    }
  }
};
</script>

<style></style>
